var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "content-class": "dialogText", "max-width": "900", light: "" },
      model: {
        value: _vm.isDialog,
        callback: function ($$v) {
          _vm.isDialog = $$v
        },
        expression: "isDialog",
      },
    },
    [
      _vm.isDialog
        ? _c(
            "v-card",
            [
              _c(
                "div",
                {
                  staticClass: "absX",
                  on: {
                    "&click": function ($event) {
                      return _vm.closeDialog(true)
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "myGray", attrs: { "x-large": "" } },
                    [_vm._v("mdi-window-close")]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "spacer-25" }),
              _c(
                "v-card-title",
                { staticClass: "headline text-center d-block" },
                [_vm._v("In welchem Gang soll diese Speise serviert werden? ")]
              ),
              _c("div", { staticClass: "spacer-15" }),
              _c(
                "v-card-actions",
                { staticClass: "text-center justify-center flex-wrap" },
                [
                  _vm.gang1
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "okBtn btn-df text-none mb-4",
                          attrs: { rounded: "" },
                          nativeOn: {
                            "&click": function ($event) {
                              $event.stopPropagation()
                              return _vm.doGang(1)
                            },
                          },
                        },
                        [_vm._v("Vorspeise ")]
                      )
                    : _vm._e(),
                  _vm.gang2
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "grayBtn btn-df text-none mb-4",
                          attrs: { rounded: "" },
                          nativeOn: {
                            "&click": function ($event) {
                              $event.stopPropagation()
                              return _vm.doGang(2)
                            },
                          },
                        },
                        [_vm._v(" Hauptspeise ")]
                      )
                    : _vm._e(),
                  _vm.gang3
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "grayBtn btn-df text-none mb-4",
                          attrs: { rounded: "" },
                          nativeOn: {
                            "&click": function ($event) {
                              $event.stopPropagation()
                              return _vm.doGang(3)
                            },
                          },
                        },
                        [_vm._v(" Dessert ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("div", { staticClass: "pb-3" }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }